import {
  DYNAMIC_COMPONENT_INIT,
  DYNAMIC_COMPONENT_DEPENDENCY_GET_SUCCESS,
  DYNAMIC_COMPONENT_INIT_WITH_STATE,
  COLLABORATION_REMOTE_DOCUMENT_UPDATE,
} from 'common/types';
import DynamicComponentActions from 'go/actions/dynamicComponent';
import {delay} from 'redux-saga';
import {put, call, take, select, fork} from 'redux-saga/effects';
import ApiActions from 'go/actions/api';
import {
  isFemaUser,
  countDependenciesToLoad,
  buildParamString,
  checkIfDefinedNonNullAndNotEmptyString,
  isToggledOnDependency,
} from 'common/utils';
import {
  ENTITY_MAP,
  ENTITY_PAGE_TYPE_GRANT,
  ENTITY_PAGE_TYPE_SUBGRANT,
  ENTITY_PAGE_TYPE_SUBAPPLICATION,
  TOKEN_LOADED,
} from 'app-ui-componentlibrary/dist/common/constants';
import _ from 'lodash';
import {
  ENDPOINT_ORGANIZATION,
  ENDPOINT_OBLIGATION,
  ENDPOINT_VENDOR,
  ENDPOINT_GRANT,
} from 'common/endpoints';

import goStore from 'go/store';

const dependencyMapping = {
  application: loadApplication,
  applicationsByOrg: loadApplicationsByOrgIdAndFOId,
  allocationsByFO: loadAllocationsByFoId,
  allocation: loadAllocationById,
  allocationEntities: loadAllocationEntities,
  allocationEntitiesByTypes: loadAllocationEntitiesByTypes,
  allocationPendingEntities: loadAllocationPendingEntities,
  communityLifeline: loadCommunityLifeline,
  hazardSources: loadHazardSources,
  fundingSources: loadfundingSources,
  fundingTypes: loadfundingTypes,
  structureTypes: loadStructureTypes,
  propertyOwnerTypes: loadPropertyOwnerTypes,
  propertyInventoryTypes: loadPropertyInventoryTypes,
  benefitCostTypes: loadBenefitCostTypes,
  mitigationActionTypes: loadMitigationActionTypes,
  landUseTypes: loadLandUseTypes,
  propertyFoundationTypes: loadPropertyFoundationTypes,
  floodZoneTypes: loadFloodZoneTypes,
  natureBasedSolutions: loadNatureBasedSolutions,
  subApplication: loadSubApplication,
  subApplicationWithConfigPath: loadSubApplicationWithConfigPath,
  subApplicationGrant: loadSubApplicationGrant,
  grant: loadGrant,
  grantIdByFOIdAndOrgId: loadGrantIdByFOIdAndOrgId,
  taskData: loadTaskByGrantIdEntityType,
  subApplicationsForGrant: loadSubApplicationsByGrantIdEntityType,
  subGrant: loadSubGrant,
  subGrantWithConfigPath: loadSubGrantWithConfigPath,
  organization: loadOrganization,
  subOrganizationBySubOrgId: loadSubOrganizationBySubOrgId,
  organizations: loadOrganizations,
  subOrganization: loadSubOrganization,
  program: loadProgram,
  fundingOpportunity: loadFundingOpportunity,
  fundingOpportunityV2: loadFundingOpportunityV2,
  foFundingOpportunityV2: loadFOFundingOpportunityV2,
  foFundingOpportunityV2WithParams: loadFundingOpportunityV2WithParams,
  fosByOrgAndSubOrg: loadFosByOrgAndSubOrg,
  programCategoryConfig: loadProgramCategoryConfig,
  foProgramCategoryConfig: loadFOProgramCategoryConfig,
  invoice: loadInvoice,
  subGrantInvoice: loadSubGrantInvoice,
  obligation: loadObligation,
  obligationStatus: loadObligationStatus,
  enhancedObligation: loadEnhancedObligation,
  approvedObligationAmount: loadApprovedObligationAmount,
  subGrantObligationAmountsByGrant: loadSubGrantObligationAmountsByGrant,
  closeout: loadCloseout,
  commitment: loadCommitment,
  commitmentDataForGrant: loadCommitmentDataForGrant,
  comment: loadComment,
  subComment: loadSubComment,
  rfaComment: loadRFAComment,
  riskAssessment: loadRiskAssessment,
  workflowTask: loadWorkflowTask,
  panelReview: loadPanelReview,
  scores: loadScores,
  panelReviewScoresV2: loadScoresV2,
  panelReviewSessionsV2: loadSessionsV2,
  panelReviewUserScoresV2: loadUserScoresV2,
  panelReviewFinalScoresV2: loadFinalScoresV2,
  panelReviewV2: loadPanelReviewV2,
  prescoreV2: loadPrescoreV2,
  fundingOpportunityData: loadFOData,
  awardRecommendation: loadAwardRecommendation,
  subAwardRecommendation: loadSubAwardRecommendation,
  subAmendmentRecommendation: loadSubAmendmentRecommendation,
  subAmendmentRecommendationsForSubGrant: loadSubAmendmentRecommendationsForSubGrant,
  legacyHMASubAmendmentRecommendationsForSubGrant: loadLegacyHMASubAmendmentRecommendationsForSubGrant,
  subAwardOrAmendmentRecommendation: loadSubAwardOrAmendmentRecommendation,
  workflowTasksForGrant: loadWorkflowTasksForGrant,
  workflowTasksForSubGrant: loadWorkflowTasksForSubGrant,
  panelReviewSessionEntityTasks: loadWorkflowTasksForSessionEntity,
  panelReviewSessionUserTasks: loadWorkflowTasksForSessionUserId,
  attachment: loadAttachment,
  applicationDynamicData: loadApplicationDynamicData,
  awardRecommendationDynamicData: loadAwardRecommendationDynamicData,
  rules: loadRules,
  templates: loadTemplates,
  subApplicationProgram: loadSubApplicationProgram,
  loadItemCodes: loadItemCodes,
  loadRefApplicantType: loadRefApplicantType,
  loadStates: loadStates,
  user: loadUser,
  amendment: loadAmendment,
  loadProgramCategories: loadProgramCategories,
  payment: loadPayment,
  financialReport: loadFinancialReport,
  bsirReport: loadBSIRReport,
  ehp: loadEhpEntity,
  ehpReview: loadEhpReviewEntity,
  ehpReviewPassthrough: loadEhpReviewEntityPassthrough,
  payments: loadPayments,
  paymentsForSubGrant: loadPaymentsForSubGrant,
  amendments: loadAmendments,
  grantApplicationExtensions: loadGrantAppExtensions,
  vendor: loadVendorData,
  financialReports: loadFinancialReports,
  bsirReports: loadBSIRReports,
  externalTasksForGrant: loadExternalTasksForGrant,
  externalTasksForSubGrant: loadExternalTasksForSubGrant,
  applicationLinkData: loadApplicationLinkData,
  rfisForAmendment: loadRfisForAmendment,
  panelReviewSession: loadSessionData,
  panelReviewSessionEntity: loadSessionEntity,
  panelReviewReviewer: loadReviewerData,
  panelReviewReviewerNames: loadUserNames,
  panelReviewAssignedEntities: loadSessionEntities,
  panelReviewAliases: loadPanelReviewAliases,
  panelReviewGroup: loadPanelGroupData,
  panelReviewerGroups: loadPanelReviewersGroupData,
  performanceProgressReport: loadPerformanceProgressReport,
  performanceProgressReports: loadPerformanceProgressReports,
  closeoutReport: loadCloseoutReport,
  closeoutReports: loadCloseoutReports,
  subCloseoutReport: loadSubCloseoutReport,
  subCloseoutReports: loadSubCloseoutReports,
  subCloseoutRecommendation: loadSubCloseoutRecommendation,
  closeoutRecommendation: loadCloseoutRecommendation,
  programmaticCloseoutReview: loadProgrammaticCloseoutReview,
  programmaticCloseoutReviews: loadProgrammaticCloseoutReviews,
  rfi: loadRfi,
  rfis: loadRfis,
  returnOfFund: loadReturnOfFund,
  rofsForSubGrant: loadRofsForSubGrant,
  rofsForGrant: loadRofsForGrant,
  rfisForGrant: loadRfisForGrant,
  rfisForParentEntity: loadRfisForParentEntity,
  activeRfisForParentEntity: loadActiveRfisForParentEntity,
  panelReviewEntity: loadPanelReviewEntity,
  disasterAreas: loadDisasterAreas,
  disaster: loadDisasterById,
  subAwardRecommendationsForGrant: loadSubAwardRecommendationsForGrant,
  awardRecommendationForFO: loadAwardRecommendationForFO,
  subAwardRecommendationForFO: loadSubAwardRecommendationForFO,
  subAmendmentRecommendationsForGrant: loadSubAmendmentRecommendationsForGrant,
  subGrantsForGrant: loadSubGrantsForGrant,
  subOrganizationsForGrant: loadSubOrganizationsForGrant,
  subCloseoutReportsForGrant: loadSubCloseoutReportsForGrant,
  subCloseoutRecommendationsForGrant: loadSubCloseoutRecommendationsForGrant,
  fundingOpportunityOrganizationData: loadFundingOpportunityOrganizationData,
  ehpReviewsForSubGrant: loadEhpReviewsForSubGrant,
  fundingOpportunityDraft: loadFundingOpportunityDraft,
  subRecipientMgmtCost: loadsubRecipientMgmtCost,
  subCloseoutRecommendationForGrant: loadSubCloseoutRecommendationForGrant,
  programDefaultConfig: loadProgramDefaultConfig,
  subApplicationFromSubGrantId: loadSubApplicationFromSubGrantId,
};

export default function* dependencySaga() {
  yield take([
    DYNAMIC_COMPONENT_INIT,
    DYNAMIC_COMPONENT_INIT_WITH_STATE,
    DYNAMIC_COMPONENT_DEPENDENCY_GET_SUCCESS,
    COLLABORATION_REMOTE_DOCUMENT_UPDATE,
  ]);
  yield fork(waitForDependencyChangeGate);
  yield call(dependencySaga);
}

export function* waitForDependencyChangeGate() {
  const state = yield select();
  const toggles = _.get(state, 'toggles.toggles');
  const isWaitForContextToggled = _.includes(toggles, 'waitForContextBeforeDependencies');
  if (isWaitForContextToggled) {
    const userId = _.get(state, 'auth.token.userId');
    const profilePresent = !!_.get(state, 'profile.emailAdr');
    if (userId && profilePresent) {
      yield fork(waitForDependencyChange);
      return;
    }
    // we don't have everything, loop back around.
    if (userId && !profilePresent) {
      yield put(ApiActions.profile.getUser(userId));
    }
    yield delay(1000);
    yield fork(waitForDependencyChangeGate);
  } else {
    yield fork(waitForDependencyChange);
  }
}

export function* waitForDependencyChange() {
  const state = yield select();
  const {config} = state.dynamicComponent;
  const toggles = _.get(state, 'toggles.toggles');
  const numDependenciesLoaded = _.get(
    state,
    'dynamicComponent.context.numLoadedSuccessfully'
  );

  const dependencies = _.get(
    config,
    'dependencies',
    _.get(config, 'payload.dependencies', [])
  );
  const dependenciesToLoad = countDependenciesToLoad(
    dependencies,
    isFemaUser(_.get(state, 'auth.permissions')),
    toggles
  );

  if (numDependenciesLoaded === dependenciesToLoad) {
    yield put(DynamicComponentActions.validateConfigRules());
  }
  for (var i = 0; i < dependencies.length; i++) {
    yield call(pickDependencyToLoad, dependencies[i], state);
  }
}

// Ensure to check if the dependency is loaded already in the if statement
//TODO create object with dependency loader object that is keyed off of properties grab function and execute
export function* pickDependencyToLoad(dependency, state, {toggle} = {}) {
  const {data} = state.dynamicComponent;
  const auth = _.get(state, 'auth');
  const toggles = _.get(state, 'toggles');
  const token = _.get(auth, 'token');

  let context = Object.assign({}, state.dynamicComponent.context);
  context.auth = auth;
  context.toggles = toggles;
  context.profile = _.get(state, 'profile');
  let loader;
  if (typeof dependency === 'object') {
    loader = dependencyMapping[dependency.dependency];
  } else {
    loader = dependencyMapping[dependency];
  }
  let optional = dependency.optional ? dependency.optional : false;
  if (loader !== undefined) {
    const toggles = _.get(context, 'toggles.toggles');
    let isToggledOnDependencyFlag = isToggledOnDependency(toggle, toggles, null);
    if (isToggledOnDependencyFlag) {
      yield loader(
        data,
        context,
        token,
        optional,
        _.get(dependency, 'dependencyConfig', _.get(dependency, 'config'))
      );
    }
  }
}

// does the redux interaction for all methods below
function loadDependency() {
  return put(ApiActions.dependencies.get(...arguments));
}

function forceSucceedDependency(objectType) {
  return goStore.store.dispatch({
    type: DYNAMIC_COMPONENT_DEPENDENCY_GET_SUCCESS,
    meta: {objectType: objectType},
    payload: {isLoading: false},
  });
}

function loadApplication(data, context, token, optional) {
  if (
    (_.get(_.get(data, 0), 'applicationId') !== undefined ||
      _.get(context, 'workflowTask.processVariables.grantId')) &&
    context.applicationDynamicData === undefined
  ) {
    const applicationId =
      _.get(_.get(data, 0), 'applicationId') ||
      _.get(context, 'workflowTask.processVariables.grantId');

    return loadDependency(
      'applicationDynamicData',
      applicationId,
      token,
      optional,
      '/application'
    );
  }
}

function loadAllocationsByFoId(data, context, token, optional, config) {
  const foId = _.get(
    data,
    'fundingOpportunityId',
    _.get(
      context,
      'grant.fundingOpportunityId',
      _.get(context, 'subGrant.fundingOpportunityId')
    )
  );
  if (foId !== undefined && context.allocationsByFO === undefined) {
    return loadDependency(
      'allocationsByFO',
      '',
      token,
      optional,
      `fundingOpportunityId/${foId}`,
      {
        inPayloadObj: true,
      }
    );
  }
}

function loadAllocationById(data, context, token, optional) {
  const allocationId = _.get(
    data,
    'allocationId',
    _.get(
      data,
      'sysAllocationId',
      _.get(context, 'workflowTask.processVariables.allocationId')
    )
  );

  if (allocationId !== undefined && context.allocation === undefined) {
    return loadDependency('allocation', '', token, optional, `/${allocationId}`);
  }
}

function loadAllocationEntities(data, context, token, optional, config) {
  const allocationId = _.get(
    data,
    'allocationId',
    _.get(
      data,
      'sysAllocationId',
      _.get(context, 'workflowTask.processVariables.allocationId')
    )
  );

  const fundingOpportunityId = _.get(data, 'fundingOpportunityId');
  const entityType =
    config !== undefined ? config.dynamicParams.entityType : 'subAwardRecommendation';

  if (
    allocationId !== undefined &&
    fundingOpportunityId !== undefined &&
    entityType !== undefined &&
    context.allocationEntities === undefined
  ) {
    return loadDependency(
      'allocationEntities',
      '',
      token,
      optional,
      `/fundingOpportunityId/${fundingOpportunityId}/allocationId/${allocationId}/entityType/${entityType}`
    );
  }
}

function loadAllocationEntitiesByTypes(data, context, token, optional, config) {
  const allocationId = _.get(
    data,
    'allocationId',
    _.get(
      data,
      'sysAllocationId',
      _.get(context, 'workflowTask.processVariables.allocationId')
    )
  );

  const fundingOpportunityId = _.get(data, 'fundingOpportunityId');
  const entityTypes =
    config !== undefined
      ? _.join(_.get(config, 'dynamicParams.entityTypes'), ',')
      : 'subAwardRecommendation';

  if (
    allocationId !== undefined &&
    fundingOpportunityId !== undefined &&
    entityTypes !== undefined &&
    context.allocationEntitiesByTypes === undefined
  ) {
    return loadDependency(
      'allocationEntitiesByTypes',
      '',
      token,
      optional,
      `/fundingOpportunityId/${fundingOpportunityId}/allocationId/${allocationId}/entityTypes/${entityTypes}`
    );
  }
}

function loadAllocationPendingEntities(data, context, token, optional) {
  const allocationId = _.get(
    data,
    'allocationId',
    _.get(
      data,
      'sysAllocationId',
      _.get(context, 'workflowTask.processVariables.allocationId')
    )
  );
  if (allocationId !== undefined && context.allocationPendingEntities === undefined) {
    return loadDependency(
      'allocationPendingEntities',
      '',
      token,
      optional,
      `allocation/${allocationId}/entities`
    );
  }
}

function loadRfisForAmendment(data, context, token, optional, config) {
  return loadDependencyWithParams(
    data,
    context,
    token,
    optional,
    config,
    'rfisForAmendment'
  );
}

function loadRfisForParentEntity(data, context, token, optional, config) {
  return loadDependencyWithParams(
    data,
    context,
    token,
    optional,
    config,
    'rfisForParentEntity'
  );
}

function loadActiveRfisForParentEntity(data, context, token, optional, config) {
  return loadDependencyWithParams(
    data,
    context,
    token,
    optional,
    config,
    'activeRfisForParentEntity'
  );
}

function loadApplicationLinkData(data, context, token, optional, config) {
  return loadDependencyWithParams(
    data,
    context,
    token,
    optional,
    config,
    'applicationLinkData'
  );
}

function loadLegacyHMASubAmendmentRecommendationsForSubGrant(
  data,
  context,
  token,
  optional,
  config
) {
  return loadDependencyWithParams(
    data,
    context,
    token,
    optional,
    config,
    'legacyHMASubAmendmentRecommendationsForSubGrant'
  );
}

function loadCommitmentDataForGrant(data, context, token, optional, config) {
  // subgrant level commitment data
  return loadDependencyWithParams(
    data,
    context,
    token,
    optional,
    config,
    'commitmentDataForGrant'
  );
}

function loadFundingOpportunityV2WithParams(data, context, token, optional, config) {
  return loadDependencyWithParams(
    data,
    context,
    token,
    optional,
    config,
    'fundingOpportunityV2'
  );
}

function loadDependencyWithParams(data, context, token, optional, config, dependency) {
  const payload = {...context, data};
  const Id = _.get(payload, config.id);
  let extra = '?';
  const url = config.url ? config.url : '';
  if (config) {
    let params = [];
    _.each(config.dynamicParams, (value, key) => {
      // raw value let's you define an exact value for your parameter without needing it to exist in context
      if (value.rawValue) {
        params.push(`${key}=` + value.rawValue);
      } else {
        params.push(`${key}=` + _.get(context, value, value));
      }
    });
    extra = extra + _.join(params, '&');
  }
  if (Id !== undefined && context[dependency] === undefined) {
    return loadDependency(dependency, url, token, optional, extra);
  }
}

function loadGrantIdByFOIdAndOrgId(data, context, token, optional) {
  const organizationId = _.get(data, 'organizationId');
  const fundingOpportunityId = _.get(data, 'fundingOpportunityId');

  if (
    organizationId !== undefined &&
    fundingOpportunityId !== undefined &&
    context.grantIdByFOIdAndOrgId === undefined
  ) {
    return loadDependency(
      'grantIdByFOIdAndOrgId',
      '',
      token,
      optional,
      `organization/${organizationId}/fundingOpportunityId/${fundingOpportunityId}/grantId`
    );
  }
}

function loadApplicationsByOrgIdAndFOId(data, context, token, optional) {
  const organizationId = _.get(data, 'organizationId');
  const fundingOpportunityId = _.get(data, 'fundingOpportunityId');

  if (
    organizationId !== undefined &&
    fundingOpportunityId !== undefined &&
    context.applicationsByOrg === undefined
  ) {
    return loadDependency(
      'applicationsByOrg',
      '',
      token,
      optional,
      `organization/${organizationId}/fundingOpportunityId/${fundingOpportunityId}/entityType/application`
    );
  }
}

function loadSubApplicationGrant(data, context, token, optional) {
  const subAppEntityId =
    _.get(data, 'entityType') === 'subApplication'
      ? _.get(data, 'entityId')
      : _.get(data, 'entityType') === 'completeRfiUserTask'
      ? _.get(data, 'subGrantId')
      : _.get(
          context,
          'workflowTask.processVariables.subApplication.subGrantId',
          _.get(
            context,
            'workflowTask.processVariables.subGrantId',
            _.get(
              context,
              'workflowTask.processVariables.entityId',
              _.get(data, 'subGrantId')
            )
          )
        );

  const grantId = _.get(context, 'subGrant.grantId', _.get(context, 'grant.entityId'));

  if (
    subAppEntityId !== undefined &&
    grantId !== undefined &&
    context.subApplicationGrant === undefined
  ) {
    return loadDependency(
      'subApplicationGrant',
      grantId,
      token,
      optional,
      `/entityType/subApplication/subGrant/${subAppEntityId}`
    );
  }
}
function loadSubApplication(data, context, token, optional) {
  const subAppEntityId =
    _.get(data, 'entityType') === 'subApplication'
      ? _.get(data, 'entityId')
      : _.get(context, 'workflowTask.processVariables.entityId') ||
        _.get(context, 'workflowTask.processVariables.subApplication.subGrantId') ||
        _.get(data, 'subGrantId');

  if (subAppEntityId !== undefined && context.subApplication === undefined) {
    return loadDependency('subApplication', subAppEntityId, token, optional);
  }
}
function loadSubApplicationWithConfigPath(data, context, token, optional, config) {
  const subAppEntityId = _.get(
    _.get(config, 'root') === 'context' ? context : data,
    _.get(config, 'dataPath')
  );

  if (subAppEntityId !== undefined && context.subApplication === undefined) {
    return loadDependency('subApplication', subAppEntityId, token, optional);
  }
}

function loadCommunityLifeline(data, context, token, optional) {
  const id = 'codelist/COMMUNITY_LIFELINE';
  if (context.communityLifeline === undefined) {
    return loadDependency('communityLifeline', id, token, optional);
  }
}

function loadHazardSources(data, context, token, optional) {
  const id = 'codelist/HAZARD_SOURCE';
  if (context.hazardSources === undefined) {
    return loadDependency('hazardSources', id, token, optional);
  }
}

function loadfundingSources(data, context, token, optional) {
  const id = 'codelist/FUNDING_SOURCE';
  if (context.fundingSources === undefined) {
    return loadDependency('fundingSources', id, token, optional);
  }
}

function loadfundingTypes(data, context, token, optional) {
  const id = 'codelist/FUNDING_TYPE';
  if (context.fundingTypes === undefined) {
    return loadDependency('fundingTypes', id, token, optional);
  }
}

function loadStructureTypes(data, context, token, optional) {
  const id = 'codelist/STRUCTURE_TYPE';
  if (context.structureTypes === undefined) {
    return loadDependency('structureTypes', id, token, optional);
  }
}

function loadPropertyOwnerTypes(data, context, token, optional) {
  const id = 'codelist/PROPERTY_OWNER_TYPE';
  if (context.propertyOwnerTypes === undefined) {
    return loadDependency('propertyOwnerTypes', id, token, optional);
  }
}

function loadPropertyInventoryTypes(data, context, token, optional) {
  const id = 'codelist/PROPERTY_INVENTORY_TYPE';
  if (context.propertyInventoryTypes === undefined) {
    return loadDependency('propertyInventoryTypes', id, token, optional);
  }
}

function loadBenefitCostTypes(data, context, token, optional) {
  const id = 'codelist/BENEFIT_COST_TYPE';
  if (context.benefitCostTypes === undefined) {
    return loadDependency('benefitCostTypes', id, token, optional);
  }
}

function loadMitigationActionTypes(data, context, token, optional) {
  const id = 'codelist/MITIGATION_ACTION';
  if (context.mitigationActionTypes === undefined) {
    return loadDependency('mitigationActionTypes', id, token, optional);
  }
}

function loadLandUseTypes(data, context, token, optional) {
  const id = 'codelist/INVENTORY_LAND_USE';
  if (context.landUseTypes === undefined) {
    return loadDependency('landUseTypes', id, token, optional);
  }
}

function loadPropertyFoundationTypes(data, context, token, optional) {
  const id = 'codelist/PROPERTY_FOUNDATION_TYPE';
  if (context.propertyFoundationTypes === undefined) {
    return loadDependency('propertyFoundationTypes', id, token, optional);
  }
}

function loadFloodZoneTypes(data, context, token, optional) {
  const id = 'codelist/FLOOD_ZONE_TYPE';
  if (context.floodZoneTypes === undefined) {
    return loadDependency('floodZoneTypes', id, token, optional);
  }
}

function loadNatureBasedSolutions(data, context, token, optional) {
  const id = 'codelist/NATURE_BASED_SOLUTION';
  if (context.natureBasedSolutions === undefined) {
    return loadDependency('natureBasedSolutions', id, token, optional);
  }
}

function loadProgramCategories(data, context, token, optional) {
  const id = 'codelist/PROGRAM_CATEGORY';
  if (context.loadProgramCategories === undefined) {
    return loadDependency('loadProgramCategories', id, token, optional);
  }
}

// TODO, point at dynamicData instead of grant svc
function loadGrant(data, context, token, optional, config) {
  const grantId =
    _.get(data, 'grantId') ||
    _.get(data, 'payload.grantId') || // todo, remove this condition
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'applicationDynamicData.grantId') ||
    _.get(context, 'subGrant.grantId');
  const sessionId = _.get(context, 'workflowTask.processVariables.sessionId');
  if (sessionId !== undefined && grantId !== undefined && context.grant === undefined) {
    return loadDependency(
      'grant',
      `?grantId=${grantId}&sessionId=${sessionId}`,
      token,
      optional
    );
  } else if (grantId !== undefined && context.grant === undefined) {
    return loadDependency('grant', `?grantId=${grantId}`, token, optional);
  }
}

function loadTaskByGrantIdEntityType(data, context, token, optional) {
  const grantId =
    _.get(data, 'grantId') ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'applicationDynamicData.grantId');
  const entityType = _.get(optional, 'entityType');

  if (
    grantId !== undefined &&
    entityType !== undefined &&
    context.taskData === undefined
  ) {
    return loadDependency(
      'taskData',
      grantId,
      token,
      optional,
      `/entityType/${entityType}/all`
    );
  }
}

function loadSubApplicationsByGrantIdEntityType(data, context, token, optional) {
  const grantId =
    _.get(data, 'grantId') ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'application.grantId') ||
    _.get(context, 'applicationDynamicData.grantId') ||
    _.get(context, 'grant.grantId');
  if (grantId && context.subApplicationsForGrant === undefined) {
    return loadDependency(
      'subApplicationsForGrant',
      grantId,
      token,
      optional,
      '/entityType/subApplication/all',
      {
        inPayloadObj: true,
      }
    );
  }
}

function loadSubGrantWithConfigPath(data, context, token, optional, config) {
  const subGrantId = _.get(
    _.get(config, 'root') === 'context' ? context : data,
    _.get(config, 'dataPath')
  );
  if (subGrantId !== undefined && context.subGrant === undefined) {
    return loadDependency('subGrant', subGrantId, token, optional);
  }
}
function loadSubGrant(data, context, token, optional, config) {
  const subGrantId =
    data.subGrantId ||
    _.get(context, 'workflowTask.processVariables.subApplication.subGrantId');

  if (subGrantId !== undefined && context.subGrant === undefined) {
    return loadDependency('subGrant', subGrantId, token, optional);
  }
}

function loadSubGrantsForGrant(data, context, token, optional) {
  const grantId =
    _.get(data, 'grantId') ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'application.grantId') ||
    _.get(context, 'applicationDynamicData.grantId') ||
    _.get(context, 'grant.grantId');
  if (grantId && context.subGrantsForGrant === undefined) {
    return loadDependency(
      'subGrantsForGrant',
      grantId,
      token,
      optional,
      '/entityType/subGrant/all',
      {
        inPayloadObj: true,
      }
    );
  }
}

function loadSubCloseoutReportsForGrant(data, context, token, optional) {
  const grantId =
    _.get(data, 'grantId') ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'application.grantId') ||
    _.get(context, 'applicationDynamicData.grantId') ||
    _.get(context, 'grant.grantId');
  if (grantId && context.subCloseoutReportsForGrant === undefined) {
    return loadDependency(
      'subCloseoutReportsForGrant',
      grantId,
      token,
      optional,
      '/entityType/subCloseoutReport/all',
      {
        inPayloadObj: true,
      }
    );
  }
}

function loadSubCloseoutRecommendationsForGrant(data, context, token, optional) {
  const grantId =
    _.get(data, 'grantId') ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'application.grantId') ||
    _.get(context, 'applicationDynamicData.grantId') ||
    _.get(context, 'grant.grantId');
  if (grantId && context.subCloseoutRecommendationsForGrant === undefined) {
    return loadDependency(
      'subCloseoutRecommendationsForGrant',
      grantId,
      token,
      optional,
      '/entityType/subCloseoutRecommendation/all',
      {
        inPayloadObj: true,
      }
    );
  }
}

function loadSubOrganization(data, context, token, optional) {
  const permissions = _.get(context, 'auth.permissions');
  let orgList = [];
  permissions.forEach((permission) => {
    let permArray = permission.split(':');
    let type = permArray[0];
    if (
      type === ENTITY_MAP.PROGRAM_ORGANIZATION.code ||
      type === ENTITY_MAP.PROGRAM_ORGANIZATION_SUBORGANIZATION.code
    ) {
      orgList.push(permArray[1].split('_')[0]);
    }
  });
  orgList = _.uniq(orgList);
  const orgId =
    _.get(data, 'organizationId', _.get(context, 'subApplicationGrant.organizationId')) ||
    _.get(context, 'grant.organizationId') ||
    _.get(context, 'subApplication.organizationId');
  const subOrgId =
    _.get(data, 'subOrgId') ||
    _.get(context, 'subApplication.subOrgId') ||
    _.get(context, 'subApplicationGrant.subOrgId');
  if (
    subOrgId !== undefined &&
    !_.includes(orgList, subOrgId) &&
    context.subOrganization === undefined
  ) {
    const endPointToUse = `${orgId}/suborganization/${subOrgId}`;
    return loadDependency('subOrganization', endPointToUse, token, optional);
  } else if (
    orgId !== undefined &&
    subOrgId !== undefined &&
    context.subOrganization === undefined
  ) {
    return loadDependency('subOrganization', orgId, token, optional);
  }
}

function loadOrganization(data, context, token, optional) {
  let orgId =
    _.get(
      context,
      'awardRecommendation.organizationId',
      _.get(context, 'grant.organizationId')
    ) ||
    _.get(data, 'organizationId') ||
    _.get(context, 'subApplicationGrant.organizationId');
  if (orgId !== undefined && context.organization === undefined) {
    return loadDependency('organization', orgId, token, optional);
  }
}

function loadSubOrganizationBySubOrgId(data, context, token, optional, config) {
  const subOrgId = _.get(
    _.get(config, 'root') === 'context' ? context : data,
    _.get(config, 'dataPath')
  );
  if (subOrgId !== undefined && context.subOrganizationBySubOrgId === undefined) {
    return loadDependency('subOrganizationBySubOrgId', subOrgId, token, optional);
  }
}

function loadSubOrganizationsForGrant(data, context, token, optional) {
  const entities = _.get(
    context,
    'subGrantsForGrant.payload',
    _.get(context, 'subAwardRecommendationsForGrant.payload') ||
      _.get(context, 'subAmendmentRecommendationsForGrant.payload') ||
      _.get(context, 'commitmentDataForGrant.items')
  );
  if (entities && !entities.loading && context.subOrganizationsForGrant === undefined) {
    let subOrgIds = _.map(entities, (entity) => {
      return _.get(entity, 'subOrgId');
    });

    return loadDependency(
      'subOrganizationsForGrant',
      'organizations',
      token,
      optional,
      '',
      {
        method: 'POST',
        body: {
          ids: _.map(
            _.filter(subOrgIds, (subOrgId) =>
              checkIfDefinedNonNullAndNotEmptyString(subOrgId)
            ),
            _.toNumber
          ),
        },
        inPayloadObj: true,
      }
    );
  }
}

function loadOrganizations(data, context, token, optional) {
  const permissions = _.get(context, 'auth.permissions');
  let orgList = [];
  permissions.forEach((permission) => {
    let permArray = permission.split(':');
    let type = permArray[0];
    if (
      type === ENTITY_MAP.ORGANIZATION.code ||
      type === ENTITY_MAP.PROGRAM_ORGANIZATION.code
    ) {
      orgList.push(permArray[1].split('_')[0]);
    }
  });
  orgList = _.uniq(orgList);
  if (!_.isEmpty(orgList) && context.organizations === undefined) {
    return loadDependency('organizations', 'organizations', token, optional, '', {
      method: 'POST',
      body: {
        ids: _.map(
          _.filter(orgList, (orgId) => checkIfDefinedNonNullAndNotEmptyString(orgId)),
          _.toNumber
        ), // api accepts array of integers
      },
    });
  }
}

function loadProgram(data, context, token, optional) {
  const programId = _.get(
    data,
    'programId',
    _.get(context, 'grant.programId', _.get(context, 'fundingOpportunityData.programId'))
  );
  if (programId !== undefined && context.program === undefined) {
    return loadDependency('program', programId, token, optional);
  }
}

function loadProgramDefaultConfig(data, context, token, optional) {
  const programId = _.get(
    data,
    'programId',
    _.get(
      context,
      'grant.programId',
      _.get(
        context,
        'fundingOpportunityData.programId',
        _.get(context, 'program.programId')
      )
    )
  );
  if (programId !== undefined && context.programDefaultConfig === undefined) {
    return loadDependency(
      'programDefaultConfig',
      programId,
      token,
      optional,
      '?searchParams=""'
    );
  }
}

function loadFundingOpportunity(data, context, token, optional) {
  let fundingOpportunityId =
    _.get(context, 'grant.fundingOpportunityId') ||
    _.get(context, 'panelReviewSession.fundingOpportunityId');

  let hasOrgInfo =
    _.has(context, 'grant.payload.organizationInformation') ||
    _.has(context, 'applicationDynamicData.payload.organizationInformation');

  if (fundingOpportunityId && hasOrgInfo && context.fundingOpportunity === undefined) {
    let eligibleApplicantType = _.get(
      context,
      'grant.payload.organizationInformation.type',
      _.get(context, 'applicationDynamicData.payload.organizationInformation.type')
    );
    let isMicrogrant = _.get(
      context,
      'grant.payload.program.isMicrogrant',
      _.get(context, 'applicationDynamicData.payload.requestInformation.isMicroGrant')
    );
    let fundingStream = _.get(
      context,
      'grant.payload.program.fundingStream',
      _.get(context, 'applicationDynamicData.payload.requestInformation.fundingStream')
    );
    return loadDependency(
      'fundingOpportunity',
      fundingOpportunityId,
      token,
      optional,
      '/config?eligibleApplicantType=' +
        encodeURI(eligibleApplicantType) +
        '&fundingStream=' +
        encodeURI(fundingStream) +
        '&isAvailableForMicrogrant=' +
        isMicrogrant
    );
  } else if (
    fundingOpportunityId &&
    context.fundingOpportunity === undefined &&
    context.panelReviewSession
  ) {
    return loadDependency('fundingOpportunity', fundingOpportunityId, token);
  }
}

function loadFundingOpportunityV2(data, context, token, optional) {
  let configType = 'fo';
  let fundingOpportunityId =
    _.get(context, 'grant.fundingOpportunityId') ||
    _.get(data, 'payload.fundingOpportunity') ||
    _.get(context, 'subApplicationGrant.fundingOpportunityId') ||
    _.get(data, 'fundingOpportunityId');

  if (
    !(optional && optional.skipSubAppFOConfig) &&
    'subApplication' === _.get(data, 'entityType')
  ) {
    configType = 'pc';
    fundingOpportunityId = _.get(data, 'categoryId');
  }
  if (
    !(optional && optional.skipSubAppFOConfig) &&
    context.subApplication !== undefined &&
    'subApplication' === context.subApplication.entityType
  ) {
    configType = 'pc';
    fundingOpportunityId = _.get(context, 'subApplication.categoryId');
  }

  if (fundingOpportunityId && context.fundingOpportunityV2 === undefined) {
    return loadDependency(
      'fundingOpportunityV2',
      `${configType}/${fundingOpportunityId}/objectDefinition/fundingOpportunityConfig`,
      token,
      optional
    );
  }
}

function loadFOFundingOpportunityV2(data, context, token, optional) {
  let configType = 'fo';
  let fundingOpportunityId =
    _.get(context, 'grant.fundingOpportunityId') ||
    _.get(context, 'subApplicationGrant.fundingOpportunityId') ||
    _.get(data, 'fundingOpportunityId');

  if (fundingOpportunityId && context.fundingOpportunityV2 === undefined) {
    return loadDependency(
      'fundingOpportunityV2',
      `${configType}/${fundingOpportunityId}/objectDefinition/fundingOpportunityConfig`,
      token,
      optional
    );
  }
}

function loadFosByOrgAndSubOrg(data, context, token, optional) {
  const organizationId =
    _.get(context, 'subApplication.organizationId') ||
    _.get(context, 'subApplicationGrant.organizationId') ||
    _.get(data, 'organizationId');

  const subOrgId =
    _.get(context, 'subApplication.subOrgId') ||
    _.get(context, 'subApplicationGrant.subOrgId') ||
    _.get(data, 'subOrgId');

  if (organizationId && subOrgId && context.fosByOrgAndSubOrg === undefined) {
    return loadDependency(
      'fosByOrgAndSubOrg',
      `organization/${organizationId}/subOrganization/${subOrgId}`,
      token,
      optional
    );
  }
}

function loadGrantAppExtensions(data, context, token, optional) {
  // const programId = _.get(data, 'programId', _.get(context, 'grant.programId'));
  if (data.grantId !== undefined && context.grantApplicationExtensions === undefined) {
    return loadDependency(
      'grantApplicationExtensions',
      `${data.grantId}/appExtension`,
      token,
      optional
    );
  }
}

function loadProgramCategoryConfig(data, context, token, optional) {
  let categoryId =
    _.get(context, 'grant.categoryId') ||
    _.get(data, 'payload.categoryId') ||
    _.get(data, 'categoryId') ||
    _.get(context, 'subApplicationGrant.categoryId') ||
    _.get(context, 'subApplication.categoryId') ||
    _.get(optional, 'categoryId');

  if (categoryId && context.programCategoryConfig === undefined) {
    return loadDependency(
      'programCategoryConfig',
      `pc/${categoryId}/pcConfig`,
      token,
      optional
    );
  }
}

function loadFOProgramCategoryConfig(data, context, token, optional) {
  const fundingOpportunityId =
    _.get(data, 'fundingOpportunityId') || _.get(context, 'grant.fundingOpportunityId');

  if (fundingOpportunityId && context.programCategoryConfig === undefined) {
    return loadDependency(
      'programCategoryConfig',
      `fo/${fundingOpportunityId}/pcConfig`,
      token,
      optional
    );
  }
}

function loadInvoice(data, context, token, optional) {
  if (context.grant !== undefined && context.grant.id && context.invoice === undefined) {
    return loadDependency('invoice', `grantId/${context.grant.id}`, token, optional);
  }
}

function loadSubGrantInvoice(data, context, token, optional) {
  if (
    context.grant !== undefined &&
    context.grant.id &&
    context.subGrant !== undefined &&
    context.subGrant.entityId &&
    context.invoice === undefined
  ) {
    return loadDependency(
      'invoice',
      `grantId/${context.grant.id}/subGrantId/${context.subGrant.entityId}`,
      token,
      optional
    );
  }
}

function loadAttachment(data, context, token, optional) {
  if (context.grant !== undefined && context.attachment === undefined) {
    return loadDependency('attachment', context.grant.id, token, optional);
  }
}

function loadObligation(data, context, token, optional) {
  if (_.get(context, 'grant.id') !== undefined && context.obligation === undefined) {
    return loadDependency('obligation', `grant/${context.grant.id}`, token, optional);
  }
}

function loadEnhancedObligation(data, context, token, optional) {
  if (_.get(context, 'grant.id') !== undefined && context.obligation === undefined) {
    return loadDependency('obligation', `grantId/${context.grant.id}`, token, optional);
  }
}

function loadObligationStatus(data, context, token, optional) {
  if (
    _.get(context, 'grant.id') !== undefined &&
    context.obligationStatus === undefined
  ) {
    return loadDependency(
      'obligationStatus',
      `getObligationDocumentStatus/grantId/${context.grant.id}`,
      token,
      optional
    );
  }
}

function loadSubGrantObligationAmountsByGrant(data, context, token, optional) {
  if (
    _.get(context, 'grant.id') !== undefined &&
    context.subGrantObligationAmountsByGrant === undefined
  ) {
    return loadDependency(
      'subGrantObligationAmountsByGrant',
      `subGrantObligationAmounts/${context.grant.id}`,
      token,
      optional
    );
  }
}

function loadApprovedObligationAmount(data, context, token, optional, config) {
  if (context.approvedObligationAmount === undefined) {
    let entityType;
    if (config && config.entityType) {
      entityType = config.entityType;
    } else {
      entityType = _.get(data, 'subGrantId') ? 'subGrant' : 'grant';
    }
    let entityId =
      entityType === 'grant' ? _.get(data, 'grantId') : _.get(data, 'subGrantId');
    return loadDependency(
      'approvedObligationAmount',
      'entityId/' + entityId + '/entityType/' + entityType,
      token,
      optional
    );
  } else {
  }
}

function loadCloseout(data, context, token, optional) {
  const closeoutId = data.parentId || _.get(context, 'grant.closeoutId');
  if (context.closeout === undefined && closeoutId) {
    return loadDependency('closeout', closeoutId, token, optional);
  }
}

function loadCommitment(data, context, token, optional) {
  const commitmentNumber = _.get(
    context,
    'amendment.payload.commitment.commitmentNumberId',
    _.get(
      context,
      'awardRecommendation.payload.commitment.commitmentNumberId',
      _.get(
        context,
        'grant.payload.commitment.commitmentNumberId',
        _.get(context, ['fundingOpportunityData', 'commitmentNumbers', 0])
      )
    )
  );
  if (commitmentNumber !== undefined && context.commitment === undefined) {
    return loadDependency('commitment', commitmentNumber, token, optional);
  }
}

function loadComment(data, context, token, optional) {
  const grantId = data.grantId || _.get(context, 'workflowTask.processVariables.grantId');
  const entityType = _.get(context, 'grant.entityType') || ENTITY_PAGE_TYPE_GRANT;
  if (
    grantId !== undefined &&
    entityType !== undefined &&
    context.comment === undefined
  ) {
    return loadDependency(
      'comment',
      '?grantId=' + grantId + '&entityType=' + entityType,
      token,
      optional,
      '',
      {
        contextName: 'comment',
      }
    );
  }
}

function loadSubComment(data, context, token, optional, config) {
  let entityType;
  let subAppEntityId;
  if (_.get(data, 'entityType') === 'subApplication') {
    subAppEntityId = _.get(data, 'entityId');
    entityType = _.get(context, 'subApplication.entityType');
  } else if (
    _.get(context, 'subGrant.entityType') === 'subGrant' ||
    _.get(config, 'taskType', _.get(optional, 'taskType')) === 'subGrant'
  ) {
    subAppEntityId = _.get(data, 'subGrantId');
    entityType = _.get(context, 'subGrant.entityType');
  } else {
    subAppEntityId =
      _.get(context, 'workflowTask.processVariables.subApplication.subGrantId') ||
      _.get(context, 'workflowTask.processVariables.entityId');
    entityType = _.get(
      context,
      'subApplication.entityType',
      ENTITY_PAGE_TYPE_SUBAPPLICATION
    );
  }
  if (
    subAppEntityId !== undefined &&
    entityType !== undefined &&
    context.subComment === undefined
  ) {
    return loadDependency(
      'subComment',
      '?entityId=' + subAppEntityId + '&entityType=' + entityType,
      token,
      optional,
      '',
      {
        contextName: 'subComment',
      }
    );
  }
}

function loadRFAComment(data, context, token, optional, config) {
  let entityId = _.get(context, 'workflowTask.processVariables.entityId');
  if (entityId !== undefined && context.subComment === undefined) {
    return loadDependency(
      'subComment',
      '?entityId=' + entityId + '&entityType=rfa',
      token,
      optional,
      '',
      {
        contextName: 'subComment',
      }
    );
  }
}

function loadTemplates(data, context, token, optional, config) {
  if (
    context.templates === undefined &&
    !_.get(context, 'grant.loading', true) &&
    config &&
    config.templateNames
  ) {
    const params = [
      {name: 'grantId', value: context.grant.grantId},
      {
        name: 'fundingOpportunityId',
        value: context.grant.fundingOpportunityId,
      },
    ];
    const paramString = buildParamString(config.templateNames, params);
    return loadDependency('templates', '?' + paramString, token, optional);
  }
}

function loadRiskAssessment(data, context, token, optional) {
  if (context.workflowTask && context.workflowTask.processVariables) {
    const {programId, grantId} = context.workflowTask.processVariables;
    if (programId && grantId && context.riskAssessment === undefined)
      return loadDependency(
        'riskAssessment',
        'program/' + programId + '/risk?grantId=' + grantId,
        token,
        optional
      );
  }
}

function loadWorkflowTask(data, context, token, optional) {
  const taskId = data.taskId;
  if (taskId !== undefined && context.workflowTask === undefined) {
    return loadDependency('workflowTask', taskId, token, optional);
  }
}

function loadScoresV2(data, context, token, optional) {
  const sessionId = _.get(
    context,
    'workflowTask.processVariables.sessionId',
    _.get(context, 'sessionId')
  );
  const entityId = _.get(
    context,
    'workflowTask.processVariables.entityId',
    _.get(context, 'entityId')
  );
  if (sessionId && entityId && context.panelReviewScoresV2 === undefined)
    return loadDependency(
      'panelReviewScoresV2',
      sessionId,
      token,
      optional,
      `/entities/${entityId}/scores`,
      {
        inPayloadObj: true,
      }
    );
}

function loadSessionsV2(data, context, token, optional) {
  const sessions = _.get(context, 'panelReviewV2.sessionEntityScore', []);
  var url = '';
  _.forEach(sessions, (s, i) => {
    const urlParameterType = i === 0 ? '?' : '&';
    return (url += urlParameterType + 'sessionId=' + s.sessionId);
  });

  const scoresLoaded = _.get(context, 'panelReviewV2.sessionEntityScore') !== undefined;
  if (scoresLoaded && context.panelReviewSessionsV2 === undefined)
    return loadDependency('panelReviewSessionsV2', url, token, optional, '', {
      inPayloadObj: true,
    });
}

function loadUserScoresV2(data, context, token, optional) {
  if (context.workflowTask) {
    const sessionId = _.get(context, 'workflowTask.processVariables.sessionId');
    const entityId = _.get(context, 'workflowTask.processVariables.entityId');

    const userId = _.get(context, 'auth.userId');
    if (sessionId && entityId && context.panelReviewUserScoresV2 === undefined)
      return loadDependency(
        'panelReviewUserScoresV2',
        sessionId,
        token,
        optional,
        `/entities/${entityId}/scores?userId=${userId}`,
        {
          inPayloadObj: true,
        }
      );
  }
}

function loadFinalScoresV2(data, context, token, optional) {
  const entityId = _.get(
    context,
    'workflowTask.processVariables.entityId',
    _.get(context, 'entityId')
  ); //TODO include sub-grant path for HMA
  if (entityId && context.panelReviewFinalScoresV2 === undefined)
    return loadDependency('panelReviewFinalScoresV2', entityId, token, optional, '', {
      inPayloadObj: true,
    });
}

function loadPanelReview(data, context, token, optional) {
  if (context.workflowTask) {
    const applicationId = _.get(context, 'workflowTask.processVariables.grantId');

    if (applicationId && context.panelReview === undefined)
      return loadDependency('panelReview', applicationId, token, optional);
  }
}

function loadPanelReviewV2(data, context, token, optional) {
  const grantId = _.get(
    context,
    'workflowTask.processVariables.grantId',
    _.get(context.grant, 'grantId')
  );
  const entityId = grantId + '-application';
  if (grantId && entityId && context.panelReviewV2 === undefined) {
    return loadDependency(
      'panelReviewV2',
      `entities/${entityId}/scores`,
      token,
      optional,
      '',
      {
        contextName: 'panelReviewV2',
      }
    );
  }
}

function loadPrescoreV2(data, context, token, optional) {
  const applicationNumber = _.get(
    context,
    'workflowTask.processVariables.applicationId',
    _.get(context.applicationDynamicData, 'entityId')
  );

  if (applicationNumber && context.prescoreV2 === undefined) {
    return loadDependency('prescoreV2', `/${applicationNumber}`, token, optional, '', {
      inPayloadObj: true,
    });
  }
}

function loadScores(data, context, token, optional) {
  if (context.workflowTask) {
    const grantId = _.get(context, 'workflowTask.processVariables.grantId');

    if (grantId && context.scores === undefined)
      return loadDependency('scores', grantId, token, optional);
  }
}

function loadFOData(data, context, token, optional) {
  const foID = _.get(
    context,
    'grant.fundingOpportunityId',
    _.get(
      context,
      'workflowTask.processVariables.fundingOpportunityId',
      _.get(
        context,
        'subApplication.fundingOpportunityId',
        _.get(
          context,
          'subGrant.fundingOpportunityId',
          _.get(data, 'fundingOpportunityId')
        )
      )
    )
  );
  if (foID !== undefined && context.fundingOpportunityData === undefined) {
    return loadDependency('fundingOpportunityData', foID, token, optional);
  }
}

function loadAwardRecommendation(data, context, token, optional) {
  const grantId =
    data.grantId ||
    _.get(context, 'grant.grantId') ||
    _.get(context, 'workflowTask.processVariables.grantId');

  if (grantId !== undefined && context.awardRecommendation === undefined) {
    return loadDependency(
      'awardRecommendation',
      grantId,
      token,
      optional,
      '/entityType/awardRecommendation'
    );
  }
}

function loadRules(data, context, token, optional, config) {
  const grantId = data.grantId || _.get(context, 'workflowTask.processVariables.grantId');
  if (grantId !== undefined && context.rules === undefined) {
    return loadDependency(
      'rules',
      '',
      token,
      optional,
      `?grantId=${grantId}&rules=${JSON.stringify(config)}`
    );
  }
}

function loadApplicationDynamicData(data, context, token, optional) {
  const grantId =
    data?.grantId ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'entityId') ||
    _.get(context, 'grant.grantId');

  if (grantId && context.applicationDynamicData === undefined) {
    return loadDependency(
      'applicationDynamicData',
      grantId,
      token,
      optional,
      '/entityType/application'
    );
  }
}

function loadAwardRecommendationDynamicData(data, context, token, optional) {
  const grantId =
    data?.grantId ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'entityId') ||
    _.get(context, 'grant.grantId');

  if (grantId && context.applicationDynamicData === undefined) {
    return loadDependency(
      'applicationDynamicData',
      grantId,
      token,
      true,
      '/entityType/application'
    );
  }
  if (grantId && context.awardRecommendationDynamicDataRaw === undefined) {
    return loadDependency(
      'awardRecommendationDynamicDataRaw',
      grantId,
      token,
      true,
      '/entityType/awardRecommendation'
    );
  }

  if (
    grantId &&
    context.applicationDynamicData &&
    !context.applicationDynamicData.loading &&
    context.awardRecommendationDynamicDataRaw &&
    !context.awardRecommendationDynamicDataRaw.loading &&
    context.awardRecommendationDynamicData === undefined
  ) {
    const appData = context.applicationDynamicData;
    const awardRecommendation = context.awardRecommendationDynamicDataRaw;
    const copyFromPayload = {
      ...appData.payload,
    };
    delete copyFromPayload.budget;
    const payload = {
      ...copyFromPayload,
      ...awardRecommendation.payload,
    };
    const merged = {
      ...awardRecommendation,
      payload,
    };
    return put({
      type: [DYNAMIC_COMPONENT_DEPENDENCY_GET_SUCCESS],
      meta: {objectType: 'awardRecommendationDynamicData', optional},
      payload: merged,
    });
  }
}

function loadPayments(data, context, token, optional) {
  const grantId =
    data.grantId ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'grant.grantId');
  if (grantId && context.payments === undefined) {
    return loadDependency(
      'payments',
      grantId,
      token,
      optional,
      '/entityType/payment/all'
    );
  }
}

function loadPaymentsForSubGrant(data, context, token, optional) {
  const subGrantId =
    data.subGrantId ||
    _.get(context, 'workflowTask.processVariables.subGrantId') ||
    _.get(context, 'subGrant.subGrantId');
  if (subGrantId && context.paymentsForSubGrant === undefined) {
    return loadDependency(
      'paymentsForSubGrant',
      subGrantId,
      token,
      optional,
      '/entityType/payment'
    );
  }
}

function loadWorkflowTasksForGrant(data, context, token, optional, config = {}) {
  const grantId = _.get(context, 'grant.grantNumber');
  if (
    (!config.femaPermissionsOnly || isFemaUser(context.auth.permissions)) &&
    grantId !== undefined &&
    context.workflowTasksForGrant === undefined
  ) {
    return loadDependency(
      'workflowTasksForGrant',
      '',
      token,
      optional,
      `?processVariables=grantId_eq_${grantId}&withCandidateGroups=true&includeAssignedTasks=true`
    );
  }
}

function loadWorkflowTasksForSubGrant(data, context, token, optional, config = {}) {
  const subGrantId = _.get(context, 'subGrant.subGrantId');
  if (
    (!config.femaPermissionsOnly || isFemaUser(context.auth.permissions)) &&
    subGrantId !== undefined &&
    context.workflowTasksForSubGrant === undefined
  ) {
    return loadDependency(
      'workflowTasksForSubGrant',
      '',
      token,
      optional,
      `?processVariables=subGrantId_eq_${subGrantId}&withCandidateGroups=true&includeAssignedTasks=true`
    );
  }
}

function loadWorkflowTasksForSessionEntity(data, context, token, optional, config = {}) {
  const entityId = _.get(context, 'entityId');
  const sessionId = _.get(context, 'sessionId');
  if (
    (!config.femaPermissionsOnly || isFemaUser(context.auth.permissions)) &&
    entityId !== undefined &&
    context.panelReviewSessionEntityTasks === undefined
  ) {
    return loadDependency(
      'panelReviewSessionEntityTasks',
      '',
      token,
      optional,
      '?extraCols=reviewerList',
      {
        inPayloadObj: true,
        contextName: 'panelReviewSessionEntityTasks',
        method: 'POST',
        body: {
          processDefinitionKey: 'panelReview',
          processVariables: [
            {
              name: 'entityId',
              value: entityId,
              operator: 'eq',
            },
            {
              name: 'sessionId',
              value: _.parseInt(sessionId),
              operator: 'eq',
            },
          ],
        },
      }
    );
  }
}

function loadUserNames(data, context, token, optional, config = {}) {
  if (context.panelReviewSessionEntityTasks) {
    let reviewerIds = _.map(context.panelReviewSessionEntityTasks.payload, (task) => {
      if (typeof task.assignee === 'string') {
        return task.assignee;
      }
    });
    reviewerIds = _.filter(reviewerIds, (reviewer) => {
      if (reviewer) {
        return reviewer;
      }
    });
    if (
      (!config.femaPermissionsOnly || isFemaUser(context.auth.permissions)) &&
      !context.panelReviewReviewerNames &&
      _.get(context, 'panelReviewReviewerNames') === undefined &&
      _.get(context, 'panelReviewSessionEntityTasks.loading') === false
    ) {
      return loadDependency('panelReviewReviewerNames', 'users', token, optional, '', {
        contextName: 'panelReviewReviewerNames',
        method: 'POST',
        body: {
          userId: !_.isEmpty(reviewerIds) ? reviewerIds : [],
        },
      });
    }
  } else if (context.panelReviewReviewer && !context.panelReviewSessionEntityTasks) {
    if (
      (!config.femaPermissionsOnly || isFemaUser(context.auth.permissions)) &&
      !context.panelReviewReviewerNames &&
      _.get(context, 'panelReviewReviewerNames') === undefined &&
      _.get(context, 'panelReviewReviewer.loading') === false
    ) {
      let reviewerId = context.panelReviewReviewer.reviewerPK.userId;
      return loadDependency('panelReviewReviewerNames', 'users', token, optional, '', {
        contextName: 'panelReviewReviewerNames',
        method: 'POST',
        body: {
          userId: [reviewerId],
        },
      });
    }
  }
}

function loadWorkflowTasksForSessionUserId(data, context, token, optional, config = {}) {
  const assignee = _.get(context, 'entityId');
  const sessionId = _.get(context, 'sessionId');

  if (
    (!config.femaPermissionsOnly || isFemaUser(context.auth.permissions)) &&
    assignee !== undefined &&
    context.panelReviewSessionUserTasks === undefined
  ) {
    return loadDependency(
      'panelReviewSessionUserTasks',
      '',
      token,
      optional,
      `?extraCols=entityId,groupId,organizationName`,
      {
        inPayloadObj: true,
        contextName: 'panelReviewSessionUserTasks',
        method: 'POST',
        body: {
          processDefinitionKey: 'panelReview',
          assignee: assignee,
          processVariables: [
            {
              name: 'sessionId',
              value: _.parseInt(sessionId),
              operator: 'eq',
            },
          ],
        },
      }
    );
  }
}

function loadSessionEntities(data, context, token, optional, config = {}) {
  if (context.panelReviewSessionUserTasks) {
    let entityIds = _.map(context.panelReviewSessionUserTasks.payload, (task) => {
      if (typeof task.entityId === 'string') {
        return task.entityId;
      }
    });
    entityIds = _.compact(_.uniq(entityIds));
    if (
      (!config.femaPermissionsOnly || isFemaUser(context.auth.permissions)) &&
      _.get(context, 'panelReviewAssignedEntities') === undefined &&
      _.get(context, 'panelReviewSessionUserTasks.loading') === false
    ) {
      return loadDependency(
        'panelReviewAssignedEntities',
        context.sessionId,
        token,
        optional,
        `/entities?entityId=${!_.isEmpty(entityIds) ? entityIds.toString() : null}`,
        {
          inPayloadObj: true,
        }
      );
    }
  }
}

function loadSubApplicationProgram(data, context, token) {
  if (context.subApplicationProgram === undefined) {
    const activePrograms = 'programs?status=approved';
    //return loadDependency('subApplicationProgram', subAppId, token);
    const test = loadDependency('subApplicationProgram', activePrograms, token);

    return test;
  }
}

function loadItemCodes(data, context, token) {
  const id = 'itemslist';
  if (context.loadItemCodes === undefined) {
    return loadDependency('loadItemCodes', id, token);
  }
}
function loadRefApplicantType(data, context, token) {
  const id = 'codelist/APPLICATION_TYPE';
  if (context.loadRefApplicantType === undefined) {
    return loadDependency('loadRefApplicantType', id, token);
  }
}

function loadStates(data, context, token) {
  const id = 'codelist/STATE';
  if (context.loadStates === undefined) {
    return loadDependency('loadStates', id, token);
  }
}

function loadUser(data, context, token, optional) {
  let userId = _.get(context, 'workflowTask.processVariables.submittedUserId');

  if (userId !== undefined && context.user === undefined) {
    return loadDependency('user', encodeURIComponent(userId), token);
  }
}

function loadAmendment(data, context, token) {
  const amendmentId =
    data.amendmentId || _.get(context, 'workflowTask.processVariables.entityId');

  if (amendmentId && context.amendment === undefined) {
    return loadDependency('amendment', amendmentId, token);
  }
}
function loadFinancialReport(data, context, token) {
  const financialReportId = _.get(context, 'workflowTask.processVariables.entityId');

  if (financialReportId && context.financialReport === undefined) {
    return loadDependency('financialReport', financialReportId, token);
  }
}
function loadBSIRReport(data, context, token) {
  const bsirReportId = _.get(context, 'workflowTask.processVariables.entityId');

  if (bsirReportId && context.bsirReport === undefined) {
    return loadDependency('bsirReport', bsirReportId, token);
  }
}

function loadAmendments(data, context, token, optional) {
  const grantId =
    data.grantId ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'grant.grantId');

  if (grantId && context.amendments === undefined) {
    return loadDependency(
      'amendments',
      grantId,
      token,
      optional,
      '/entityType/amendment/all'
    );
  }
}

function loadPayment(data, context, token) {
  const paymentId =
    data.paymentId || _.get(context, 'workflowTask.processVariables.entityId');

  if (paymentId && context.payment === undefined) {
    return loadDependency('payment', paymentId, token);
  }
}

function loadEhpEntity(data, context, token, optional) {
  let ehpEntityId =
    _.get(context, 'workflowTask.processVariables.ehpQuestionnaireRecommendationId') ||
    _.get(data, 'payload.ehpEntityId.entityId') ||
    _.get(context, 'subApplication.payload.ehpEntityId.entityId') ||
    _.get(context, 'subApplicationGrant.payload.ehpEntityId.entityId');

  let applicationType =
    _.get(data, 'payload.applicationType') ||
    _.get(context, 'subApplication.payload.applicationType') ||
    _.get(context, 'subApplicationGrant.payload.applicationType');

  let contextObj = 'ehpData';
  if (optional && optional.contextObj) {
    ehpEntityId = _.get(context, optional.entityId);
    contextObj = optional.contextObj;
  }

  const optionalDependent = _.get(optional, 'dependent');
  if (optionalDependent) {
    const dependent = _.get({data, context}, optionalDependent);

    if (dependent && !dependent.loading) {
      if (
        applicationType &&
        applicationType === '232' &&
        ehpEntityId &&
        context[contextObj] === undefined
      ) {
        return loadDependency(contextObj, ehpEntityId, token, optional);
      }
    }
  } else {
    if (applicationType && context[contextObj] === undefined) {
      if (applicationType === '232' && ehpEntityId) {
        return loadDependency(contextObj, ehpEntityId, token, optional);
      } else {
        return loadDependency(contextObj, undefined, token, optional);
      }
    }
  }
}

function loadEhpReviewEntity(data, context, token, optional) {
  let processVarCheck = _.get(context, 'workflowTask.processVariables.reviewId');

  let reviewId = processVarCheck && processVarCheck !== 'none' ? processVarCheck : false;

  let applicationType =
    _.get(data, 'payload.applicationType') ||
    _.get(context, 'subApplication.payload.applicationType') ||
    _.get(context, 'subApplicationGrant.payload.applicationType');

  const reqAppTypes = ['232', '236'];
  if (applicationType && context.ehpReviewData === undefined) {
    if (_.includes(reqAppTypes, applicationType) && reviewId) {
      return loadDependency('ehpReviewData', reviewId, token, optional);
    } else {
      return loadDependency('ehpReviewData', '', token, optional);
    }
  }
}

function loadEhpReviewEntityPassthrough(data, context, token, optional) {
  let processVarCheck = _.get(context, 'workflowTask.processVariables.reviewId');

  let reviewId = processVarCheck && processVarCheck !== 'none' ? processVarCheck : false;

  if (
    _.get(context, 'workflowTask.processVariables') &&
    context.ehpReviewData === undefined
  ) {
    if (reviewId) {
      return loadDependency('ehpReviewData', reviewId, token, optional);
    } else {
      return loadDependency('ehpReviewData', '', token, optional);
    }
  }
}

function loadVendorData(data, context, token, optional) {
  const organization = _.get(context, 'organization');
  const toggles = _.get(context, 'toggles.toggles');
  const isUEIToggled = _.includes(toggles, 'dunsToUEI');
  if (isUEIToggled) {
    const uei = _.get(organization, 'uei', '');
    const eft = _.get(organization, 'eft', '');
    if (!_.isEmpty(uei) && !_.isEmpty(_.trim(eft)) && context.vendor === undefined) {
      return loadDependency('vendor', `?uei=${uei}&eft=${eft}`, token, optional);
    } else if (!_.isEmpty(uei) && context.vendor === undefined) {
      return loadDependency('vendor', `?uei=${uei}`, token, optional);
    }
  } else {
    const duns =
      _.get(organization, 'duns', '') + '' + (_.get(organization, 'dunsPlus4', '') || '');
    if (!_.isEmpty(duns) && context.vendor === undefined) {
      return loadDependency('vendor', `?duns=${duns}`, token, optional);
    }
  }
}

function loadFinancialReports(data, context, token, optional) {
  const grantId =
    data.grantId ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'grant.grantId');
  if (grantId && context.financialReports === undefined) {
    return loadDependency(
      'getForGrant',
      grantId,
      token,
      optional,
      '/entityType/financialReport/all',
      {
        contextName: 'financialReports',
      }
    );
  }
}

function loadBSIRReports(data, context, token, optional) {
  const grantId =
    data.grantId ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'grant.grantId');
  if (grantId && context.bsirReports === undefined) {
    return loadDependency(
      'getForGrant',
      grantId,
      token,
      optional,
      '/entityType/bsirReport/all',
      {
        contextName: 'bsirReports',
      }
    );
  }
}

function loadPerformanceProgressReport(data, context, token) {
  const performanceProgressReportId = _.get(
    context,
    'workflowTask.processVariables.entityId'
  );

  if (performanceProgressReportId && context.performanceProgressReport === undefined) {
    return loadDependency(
      'performanceProgressReport',
      performanceProgressReportId,
      token
    );
  }
}

function loadPerformanceProgressReports(data, context, token, optional) {
  const grantId =
    data.grantId ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'grant.grantId');
  if (grantId && context.performanceProgressReports === undefined) {
    return loadDependency(
      'getForGrant',
      grantId,
      token,
      optional,
      '/entityType/performanceProgressReport/all',
      {
        contextName: 'performanceProgressReports',
      }
    );
  }
}

function loadProgrammaticCloseoutReviews(data, context, token, optional) {
  const grantId =
    data.grantId ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'grant.grantId');
  if (grantId && context.programmaticCloseoutReviews === undefined) {
    return loadDependency(
      'getForGrant',
      grantId,
      token,
      optional,
      '/entityType/programmaticCloseoutReview/all',
      {
        contextName: 'programmaticCloseoutReviews',
      }
    );
  }
}

function loadProgrammaticCloseoutReview(data, context, token, optional) {
  const programmaticCloseoutReviewId =
    _.get(context, 'workflowTask.processVariables.currentProgrammaticCloseoutReviewId') ||
    _.get(context, 'programmaticCloseoutReviews.0.entityId'); //workaround until workflow updates to set/update currentProgrammaticCloseoutReviewId when new task are created
  if (programmaticCloseoutReviewId && context.programmaticCloseoutReview === undefined) {
    return loadDependency(
      'programmaticCloseoutReview',
      programmaticCloseoutReviewId,
      token
    );
  }
}

function loadCloseoutRecommendation(data, context, token, optional) {
  const grantId =
    data.grantId ||
    _.get(context, 'grant.grantId') ||
    _.get(context, 'workflowTask.processVariables.grantId');

  if (grantId !== undefined && context.closeoutRecommendation === undefined) {
    return loadDependency(
      'closeoutRecommendation',
      grantId,
      token,
      optional,
      '/entityType/closeoutRecommendation'
    );
  }
}

function loadCloseoutReport(data, context, token, optional) {
  const closeoutReportId =
    _.get(context, 'workflowTask.processVariables.closeoutReportId') ||
    _.get(context, 'workflowTask.processVariables.entityId') ||
    _.get(context, 'rfi.payload.parentEntityId');
  if (closeoutReportId && context.closeoutReport === undefined) {
    return loadDependency('closeoutReport', closeoutReportId, token);
  }
}

function loadCloseoutReports(data, context, token, optional) {
  const grantId =
    data.grantId ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'grant.grantId');
  if (grantId && context.closeoutReports === undefined) {
    return loadDependency(
      'getForGrant',
      grantId,
      token,
      optional,
      '/entityType/closeoutReport/all',
      {
        contextName: 'closeoutReports',
      }
    );
  }
}

function loadSubCloseoutReport(data, context, token, optional) {
  const grantId =
    data.grantId ||
    _.get(context, 'grant.grantId') ||
    _.get(context, 'workflowTask.processVariables.grantId');
  const subGrantId = data.subGrantId || _.get(context, 'subGrant.subGrantId');
  if (grantId && subGrantId && context.subCloseoutReport === undefined) {
    return loadDependency(
      'subCloseoutReport',
      grantId,
      token,
      optional,
      `/entityType/subCloseoutReport/subGrant/${subGrantId}`
    );
  }
}

function loadSubCloseoutReports(data, context, token, optional) {
  const subGrantId = data.subGrantId || _.get(context, 'subGrant.subGrantId');
  if (subGrantId && context.subCloseoutReports === undefined) {
    return loadDependency(
      'getForSubGrant',
      subGrantId,
      token,
      optional,
      '/entityType/subCloseoutReport',
      {
        contextName: 'subCloseoutReports',
      }
    );
  }
}

function loadSubCloseoutRecommendation(data, context, token, optional) {
  const grantId =
    data.grantId ||
    _.get(context, 'grant.grantId') ||
    _.get(context, 'workflowTask.processVariables.grantId');
  const subGrantId = data.subGrantId || _.get(context, 'subGrant.subGrantId');
  if (grantId && subGrantId && context.subCloseoutRecommendation === undefined) {
    return loadDependency(
      'subCloseoutRecommendation',
      grantId,
      token,
      optional,
      `/entityType/subCloseoutRecommendation/subGrant/${subGrantId}`
    );
  }
}

function loadSubAwardRecommendation(data, context, token, optional) {
  const grantId =
    data.grantId ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'grant.id') ||
    _.get(context, _.get(optional, 'grantId'));
  const subGrantId =
    _.get(
      data,
      'subGrantId',
      _.get(
        context,
        'workflowTask.processVariables.subGrantId',
        _.get(context, 'workflowTask.processVariables.subApplication.subGrantId')
      )
    ) || _.get(context, _.get(optional, 'subGrantId'));
  if (grantId && subGrantId && context.subAwardRecommendation === undefined) {
    return loadDependency(
      'subAwardRecommendation',
      grantId,
      token,
      optional,
      `/entityType/subAwardRecommendation/subGrant/${subGrantId}`
    );
  }
}

function loadSubAwardOrAmendmentRecommendation(data, context, token, optional) {
  const optionalDependent = _.get(optional, 'dependent');

  const dependent = _.get({data, context}, optionalDependent);
  const dependentValue = _.get(dependent, _.get(optional, 'dependentPath'));

  const entityType = dependentValue
    ? 'subAmendmentRecommendation'
    : 'subAwardRecommendation';

  const grantId =
    data.grantId ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'grant.id');
  const subGrantId = _.get(
    data,
    'subGrantId',
    _.get(
      context,
      'workflowTask.processVariables.subGrantId',
      _.get(context, 'workflowTask.processVariables.subApplication.subGrantId')
    )
  );
  if (
    grantId &&
    subGrantId &&
    (!optionalDependent || (dependent && !dependent.loading)) &&
    context.subAwardOrAmendmentRecommendation === undefined
  ) {
    return loadDependency(
      'subAwardOrAmendmentRecommendation',
      grantId,
      token,
      optional,
      `/entityType/${entityType}/subGrant/${subGrantId}`
    );
  }
}

function loadSubAmendmentRecommendation(data, context, token, optional) {
  const grantId =
    data.grantId ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'grant.id');
  const subGrantId = _.get(
    data,
    'subGrantId',
    _.get(
      context,
      'workflowTask.processVariables.subGrantId',
      _.get(
        context,
        'workflowTask.processVariables.subApplication.subGrantId',
        _.get(context, 'subGrant.entityId')
      )
    )
  );
  if (grantId && subGrantId && context.subAmendmentRecommendation === undefined) {
    return loadDependency(
      'subAmendmentRecommendation',
      grantId,
      token,
      optional,
      `/entityType/subAmendmentRecommendation/subGrant/${subGrantId}`
    );
  }
}

function loadSubAmendmentRecommendationsForSubGrant(data, context, token, optional) {
  const subGrantId =
    data.subGrantId ||
    _.get(context, 'workflowTask.processVariables.subGrantId') ||
    _.get(context, 'subGrant.subGrantId');
  if (subGrantId && context.subAmendmentRecommendationsForSubGrant === undefined) {
    return loadDependency(
      'subAmendmentRecommendationsForSubGrant',
      subGrantId,
      token,
      optional,
      '/entityType/subAmendmentRecommendation'
    );
  }
}

function loadSubAwardRecommendationsForGrant(data, context, token, optional) {
  const grantId =
    _.get(data, 'grantId') ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'application.grantId') ||
    _.get(context, 'applicationDynamicData.grantId') ||
    _.get(context, 'grant.grantId');
  if (grantId && context.subAwardRecommendationsForGrant === undefined) {
    return loadDependency(
      'subAwardRecommendationsForGrant',
      grantId,
      token,
      optional,
      '/entityType/subAwardRecommendation/all',
      {
        inPayloadObj: true,
      }
    );
  }
}

function loadAwardRecommendationForFO(data, context, token, optional) {
  const foId = _.get(data, 'fundingOpportunityId');

  if (foId && context.awardRecommendationForFO === undefined) {
    return loadDependency(
      'awardRecommendationForFO',
      foId,
      token,
      optional,
      `/entityType/awardRecommendation`
    );
  }
}

function loadSubAwardRecommendationForFO(data, context, token, optional) {
  const foId = _.get(data, 'fundingOpportunityId');

  if (foId && context.subAwardRecommendationForFO === undefined) {
    return loadDependency(
      'subAwardRecommendationForFO',
      foId,
      token,
      optional,
      `/entityType/subAwardRecommendation`
    );
  }
}

function loadSubAmendmentRecommendationsForGrant(data, context, token, optional) {
  const grantId =
    _.get(data, 'grantId') ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'application.grantId') ||
    _.get(context, 'applicationDynamicData.grantId') ||
    _.get(context, 'grant.grantId');
  if (grantId && context.subAmendmentRecommendationsForGrant === undefined) {
    return loadDependency(
      'subAmendmentRecommendationsForGrant',
      grantId,
      token,
      optional,
      '/entityType/subAmendmentRecommendation/all',
      {
        inPayloadObj: true,
      }
    );
  }
}
function loadExternalTasksForGrant(data, context, token, optional, {extraCols} = {}) {
  const grantId = data.grantId || _.get(context, 'grant.grantId');
  if (isFemaUser(context.auth.permissions)) {
    forceSucceedDependency('workflowTasksForGrant');
  } else if (
    !isFemaUser(context.auth.permissions) &&
    grantId !== undefined &&
    context.externalTasksForGrant === undefined
  ) {
    return loadDependency(
      'workflowTasksForGrant',
      '',
      token,
      optional,
      `external?${extraCols != null ? 'extraCols=' + extraCols : ''}`,
      {
        contextName: 'externalTasksForGrant',
        method: 'POST',
        body: {
          candidateGroups: context.auth.permissions,
          includeAssignedTasks: true,
          processVariables: [
            {
              name: 'grantId',
              value: grantId,
              operator: 'eq',
            },
          ],
        },
      }
    );
  }
}

function loadExternalTasksForSubGrant(data, context, token, optional, {extraCols} = {}) {
  const subGrantId = data.subGrantId || _.get(context, 'subGrant.subGrantId');
  if (isFemaUser(context.auth.permissions)) {
    forceSucceedDependency('workflowTasksForSubGrant');
  } else if (
    !isFemaUser(context.auth.permissions) &&
    subGrantId !== undefined &&
    context.externalTasksForSubGrant === undefined
  ) {
    return loadDependency(
      'workflowTasksForSubGrant',
      '',
      token,
      optional,
      `external?${extraCols != null ? 'extraCols=' + extraCols : ''}`,
      {
        contextName: 'externalTasksForSubGrant',
        method: 'POST',
        body: {
          candidateGroups: context.auth.permissions,
          includeAssignedTasks: true,
          processVariables: [
            {
              name: 'subGrantId',
              value: subGrantId,
              operator: 'eq',
            },
          ],
        },
      }
    );
  }
}

function loadSessionData(data, context, token) {
  if (context.sessionId && context.panelReviewSession === undefined) {
    return loadDependency('panelReviewSession', context.sessionId, token);
  }
}

function loadSessionEntity(data, context, token, optional) {
  if (
    context.entityId &&
    context.sessionId &&
    context.panelReviewSessionEntity === undefined
  ) {
    return loadDependency(
      'panelReviewV2Endpoint',
      context.sessionId,
      token,
      optional,
      `/entities/${context.entityId}`,
      {
        contextName: 'panelReviewSessionEntity',
      }
    );
  }
}

function loadReviewerData(data, context, token, optional) {
  let entityId = encodeURIComponent(context.entityId);
  if (
    context.entityId &&
    context.sessionId &&
    context.panelReviewReviewer === undefined
  ) {
    return loadDependency(
      'panelReviewV2Endpoint',
      context.sessionId,
      token,
      optional,
      `/reviewers/${entityId}`,
      {
        contextName: 'panelReviewReviewer',
      }
    );
  }
}

function loadPanelReviewAliases(data, context, token, optional) {
  if (context.sessionId && context.panelReviewAliases === undefined) {
    return loadDependency(
      'panelReviewV2Endpoint',
      context.sessionId,
      token,
      optional,
      '/config/aliases',
      {
        contextName: 'panelReviewAliases',
      }
    );
  }
}

function loadPanelGroupData(data, context, token, optional) {
  let groupId = context.entityId;
  if (context.entityId && context.sessionId && context.panelReviewGroup === undefined) {
    return loadDependency(
      'panelReviewV2Endpoint',
      context.sessionId,
      token,
      optional,
      `/groups/${groupId}`,
      {
        contextName: 'panelReviewGroup',
      }
    );
  }
}

function loadPanelReviewersGroupData(data, context, token, optional) {
  let sessionId = context.sessionId;
  if (context.sessionId && context.panelReviewerGroups === undefined) {
    return loadDependency(
      'panelReviewV2Endpoint',
      context.sessionId,
      token,
      optional,
      `/groupNames`,
      {
        contextName: 'panelReviewerGroups',
      }
    );
  }
}

function loadRfi(data, context, token, optional) {
  const rfiId =
    (data.entityType === 'rfi' && data.entityId) ||
    _.get(context, 'workflowTask.processVariables.rfiId');
  if (rfiId && context.rfi === undefined) {
    return loadDependency('rfi', rfiId, token);
  }
}

function loadSubApplicationFromSubGrantId(data, context, token, optional) {
  const subGrantId =
    _.get(data, 'subGrantId') ||
    _.get(context, 'subGrant.subGrantId') ||
    _.get(context, 'workflowTask.processVariables.subGrantId');
  if (subGrantId && context.subApplicationFromSubGrantId === undefined) {
    return loadDependency(
      'subApplicationFromSubGrantId',
      subGrantId,
      token,
      optional,
      '/entityType/subApplication'
    );
  }
}

function loadRfis(data, context, token, optional) {
  const subGrantId =
    _.get(context, 'subGrant.subGrantId') ||
    _.get(context, 'workflowTask.processVariables.subGrantId');
  if (subGrantId && context.rfis === undefined) {
    return loadDependency('rfis', subGrantId, token, optional, '/entityType/rfi');
  }
}

function loadReturnOfFund(data, context, token, optional) {
  const rofId =
    (data.entityType === 'returnOfFund' && data.entityId) ||
    _.get(context, 'workflowTask.processVariables.rofId');
  if (rofId && context.returnOfFund === undefined) {
    return loadDependency('returnOfFund', rofId, token);
  }
}

function loadRofsForGrant(data, context, token, optional) {
  const grantId =
    data.grantId ||
    _.get(context, 'grant.grantId') ||
    _.get(context, 'workflowTask.processVariables.grantId');
  if (grantId && context.rofsForGrant === undefined) {
    return loadDependency(
      'rofsForGrant',
      grantId,
      token,
      optional,
      '/entityType/returnOfFund/all',
      {
        contextName: 'rofsForGrant',
      }
    );
  }
}

function loadRofsForSubGrant(data, context, token, optional) {
  const subGrantId =
    _.get(context, 'subGrant.subGrantId') ||
    _.get(context, 'workflowTask.processVariables.subGrantId');
  if (subGrantId && context.rofsForSubGrant === undefined) {
    return loadDependency(
      'rofsForSubGrant',
      subGrantId,
      token,
      optional,
      '/entityType/returnOfFund',
      {
        contextName: 'rofsForSubGrant',
      }
    );
  }
}

function loadRfisForGrant(data, context, token, optional) {
  const grantId =
    data.grantId ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'grant.id');

  if (grantId && context.rfis === undefined) {
    return loadDependency(
      'getForGrant',
      grantId,
      token,
      optional,
      '/entityType/rfi/all',
      {
        contextName: 'rfis',
      }
    );
  }
}

function loadPanelReviewEntity(data, context, token, optional) {
  const grantId = _.get(context, 'panelReviewSessionEntity.grantId');

  if (grantId && context.panelReviewEntity === undefined) {
    return loadDependency(
      'panelReviewEntity',
      grantId,
      token,
      optional,
      '/entityType/application'
    );
  }
}

function loadDisasterAreas(data, context, token, optional) {
  if (context && !context.disasterAreas && context.fundingOpportunityData) {
    const dId = context.fundingOpportunityData.disasterNumber;

    if (dId !== undefined) {
      return loadDependency('disasterAreas', dId, token, false, '/designatedArea');
    }
  }
}

function loadDisasterById(data, context, token, optional) {
  const isDisasterFODraft = _.get(
    context,
    'fundingOpportunityDraft.payload.isDisasterFO'
  );
  if (
    (context && !context.disaster && context.fundingOpportunityData) ||
    (context && !context.disaster && isDisasterFODraft)
  ) {
    const dId = isDisasterFODraft
      ? context.fundingOpportunityDraft.payload.disasterNumber
      : context.fundingOpportunityData.disasterNumber;

    if (dId !== undefined) {
      return loadDependency('disaster', dId, token, false);
    }
  }
}

function loadFundingOpportunityOrganizationData(data, context, token, optional, config) {
  const fundingOpportunityId =
    _.get(data, 'fundingOpportunityId') ||
    _.get(context, 'workflowTask.processVariables.fundingOpportunityId') ||
    _.get(context, 'applicationDynamicData.fundingOpportunityId') ||
    _.get(context, 'subGrant.fundingOpportunityId');
  const organizationId =
    _.get(data, 'organizationId') ||
    _.get(context, 'workflowTask.processVariables.organizationId') ||
    _.get(context, 'applicationDynamicData.organizationId') ||
    _.get(context, 'subGrant.organizationId');
  if (
    fundingOpportunityId !== undefined &&
    organizationId !== undefined &&
    context.fundingOpportunityOrganizationData === undefined
  ) {
    return loadDependency(
      'fundingOpportunityOrganizationData',
      `org/${organizationId}/fo/${fundingOpportunityId}/entity`,
      token,
      optional
    );
  }
}

function loadEhpReviewsForSubGrant(data, context, token, optional) {
  const subGrantId =
    _.get(data, 'subGrantId') ||
    _.get(context, 'workflowTask.processVariables.subGrantId') ||
    _.get(context, 'subApplication.subGrantId') ||
    _.get(context, 'subGrant.subGrantId') ||
    _.get(context, _.get(optional, 'entityId'));

  if (subGrantId !== undefined && context.ehpReviewsForSubGrant === undefined) {
    return loadDependency('ehpReviewsForSubGrant', subGrantId, token, optional);
  }
}
function loadFundingOpportunityDraft(data, context, token, optional) {
  if (context.fundingOpportunityDraft === undefined) {
    const draftId = _.get(data, 'draftId');
    return loadDependency('fundingOpportunityDraft', draftId, token, false);
  }
}

function loadsubRecipientMgmtCost(data, context, token, optional, config) {
  return loadDependencyWithParams(
    data,
    context,
    token,
    optional,
    config,
    'subRecipientMgmtCost'
  );
}

function loadSubCloseoutRecommendationForGrant(data, context, token, optional) {
  const grantId =
    _.get(data, 'grantId') ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'application.grantId') ||
    _.get(context, 'applicationDynamicData.grantId') ||
    _.get(context, 'grant.grantId');
  if (grantId && context.subCloseoutRecommendationForGrant === undefined) {
    return loadDependency(
      'subCloseoutRecommendationForGrant',
      grantId,
      token,
      optional,
      '/entityType/subCloseoutRecommendation/all',
      {
        inPayloadObj: true,
      }
    );
  }
}
